"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "garlasco": {
    "34c18adc": [{
      "hkey": "53855f20",
      "slug": "madonna-della-bozzola",
      "name": "Madonna della Bozzola",
      "primary": true,
      "skipSearch": false
    }],
    "santuario-madonna-della-bozzola": [{
      "hkey": "53855f20",
      "slug": "madonna-della-bozzola",
      "name": "Madonna della Bozzola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;